var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25586 6.82422L0.304688 1.89844C0.0761719 1.64453 0.0761719 1.26367 0.304688 1.03516L0.888672 0.451172C1.11719 0.222656 1.49805 0.222656 1.75195 0.451172L5.6875 4.36133L9.59766 0.451172C9.85156 0.222656 10.2324 0.222656 10.4609 0.451172L11.0449 1.03516C11.2734 1.26367 11.2734 1.64453 11.0449 1.89844L6.09375 6.82422C5.86523 7.05273 5.48438 7.05273 5.25586 6.82422Z",
    fill: "#002C3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownScroll);
export default __webpack_public_path__ + "static/media/down-scroll.ab85ede212d0c39b42ce50b8818b1c73.svg";
export { ForwardRef as ReactComponent };